"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workspace = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const Workspace = ({ hasMaster, ws }) => {
    return (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
        react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('WORKSPACE')),
        react_1.default.createElement("div", { className: 'ds-viewshift-col-value' }, hasMaster?.workspaceName
            ? hasMaster.workspaceName
            : ws
                ? ws.name
                : null)));
};
exports.Workspace = Workspace;
